/* ==========================================================================
   PAPI HALLOWEEN — the season skin's behaviour. Pairs with papi-halloween.css.
   Loaded (defer) from every page's <head> in the Halloween theme only.

   Everything here is decoration or a colourway swap. Nothing touches the cart,
   the prices or the add buttons — if this file fails to load, the site is the
   everyday site in a darker palette and still sells.
   ========================================================================== */
(function () {
  'use strict';

  /* Asset base, from this file's own URL. On Shopify asset_url gives
     //…/cdn/shop/t/N/assets/papi-halloween.js?v=…, in the prototype it is
     assets/papi-halloween.js; everything this file adds sits beside it. */
  var me = document.currentScript && document.currentScript.src || '';
  var BASE = me ? me.split('papi-halloween.js')[0] : (window.PAPI_ASSET_BASE || 'assets/');
  function asset(name) { return BASE + name; }

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function img(name, cls, alt) {
    var i = document.createElement('img');
    i.src = asset(name); i.alt = alt || ''; i.decoding = 'async'; i.loading = 'lazy';
    if (!alt) i.setAttribute('aria-hidden', 'true');
    if (cls) i.className = cls;
    return i;
  }

  /* ---- 1. logos: the cream colourway --------------------------------------
     The darkgreen logos carry a dark "Pistachio" script that disappears on the
     night ground. papi-logo-cream-head is the same artwork drawn for dark
     grounds, at the same aspect as both darkgreen variants (1.79:1), so the
     swap moves nothing. Never restyle the logo itself — swap the asset. */
  function logos() {
    var re = /papi-logo-darkgreen-(stacked-head|head)\.png/;
    Array.prototype.forEach.call(document.querySelectorAll('img'), function (el) {
      if (re.test(el.src)) el.src = el.src.replace(re, 'papi-logo-cream-head.png');
      var ss = el.getAttribute('srcset');
      if (ss && re.test(ss)) el.setAttribute('srcset', ss.replace(new RegExp(re.source, 'g'), 'papi-logo-cream-head.png'));
    });
  }

  /* ---- 2. dark bands that the token remap turned bone ---------------------
     Anything still painted with the old dark green as its ground is now bone
     with night type on it — correct contrast, wrong mood. Tag it so the CSS
     flips it to aubergine with bone type. Only big blocks: a pill or button
     that happens to be bone is a deliberate light element and stays. */
  function flipBands() {
    var BONE = 'rgb(244, 234, 208)';
    Array.prototype.forEach.call(
      document.querySelectorAll('body > *, body > main > *, section, footer, aside:not(.pcart)'),
      function (el) {
        if (el.closest('.pcart')) return;
        if (el.offsetHeight < 160) return;
        if (getComputedStyle(el).backgroundColor === BONE) el.classList.add('hw-flip');
      });
  }

  /* ---- 2b. contrast repair --------------------------------------------------
     The token remap is right for nearly everything, but a handful of rules
     across the pages colour type with a LITERAL dark green (rgb(62 71 40 / .55)
     footer small print, the shop blurbs) or use --papi-shell as TYPE over a
     photo or a literal dark ground (the jar card names, the spread PDP titles).
     Remapped, both land dark-on-dark.

     Rather than chase each rule, measure: any text whose colour fails WCAG
     against the ground it actually sits on is re-coloured to bone (dark
     ground) or night (light ground), keeping its own transparency so small
     print stays small print. Hidden blocks are measured too — the sold-out
     waitlists are revealed after this runs. Excluded: the cart drawer (kept
     everyday on purpose), and labels drawn over an SVG or masked shape, where
     the computed ground is not the visible one. */
  var SKIP = '.pcart, .pcart-veil, .pcart-toast, script, style, noscript, svg, ' +
             '[class*="bubble-label"], .drip-btn__label, .hw-deco, .hw-ghost, ' +
             '.hwhero, .hwfeat, .hw-signoff';   // ours: designed for night already
  function parse(c) {
    var m = /rgba?\(([^)]+)\)/.exec(c || '');
    if (!m) return null;
    var p = m[1].split(/[ ,\/]+/).filter(Boolean).map(Number);
    return { r: p[0], g: p[1], b: p[2], a: p.length > 3 ? p[3] : 1 };
  }
  function lum(c) {
    function f(v) { v /= 255; return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4); }
    return 0.2126 * f(c.r) + 0.7152 * f(c.g) + 0.0722 * f(c.b);
  }
  function ratio(a, b) {
    var x = lum(a), y = lum(b);
    return (Math.max(x, y) + 0.05) / (Math.min(x, y) + 0.05);
  }
  function groundOf(el) {
    for (var e = el; e && e !== document.documentElement; e = e.parentElement) {
      var cs = getComputedStyle(e);
      // any url() counts as a photo, even layered under a gradient scrim
      if (/url\(/.test(cs.backgroundImage)) return 'photo';
      var c = parse(cs.backgroundColor);
      if (c && c.a > 0.5) return c;
    }
    return { r: 21, g: 16, b: 14, a: 1 };
  }
  function repair() {
    var seen = [];
    var w = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
    while (w.nextNode()) {
      var el = w.currentNode.parentElement;
      if (!el || !w.currentNode.textContent.trim() || seen.indexOf(el) !== -1) continue;
      seen.push(el);
      if (el.closest(SKIP)) continue;
      var cs = getComputedStyle(el), fg = parse(cs.color);
      if (!fg) continue;
      var bg = groundOf(el);
      var dark = bg === 'photo' || lum(bg) < 0.18;
      /* Under 3:1 only. The everyday site carries a few deliberate, measured
         pairings between 3 and 4.5 (cream on the Chip Tease pink is 4.37:1) and
         "fixing" those to bone made them worse, not better. */
      if (bg === 'photo' ? lum(fg) > 0.3 : ratio(fg, bg) >= 3) continue;
      var a = Math.max(fg.a, 0.78);
      var to = dark ? { r: 244, g: 234, b: 208 } : { r: 21, g: 16, b: 14 };
      if (bg !== 'photo' && ratio(to, bg) <= ratio(fg, bg)) continue;   // only ever improve
      el.style.setProperty('color', 'rgb(' + to.r + ' ' + to.g + ' ' + to.b + ' / ' + a + ')', 'important');
      el.setAttribute('data-hw-fixed', '');
    }
  }

  /* ---- 3. bats ------------------------------------------------------------ */
  function bats() {
    if (reduce) return;
    var layer = document.createElement('div');
    layer.className = 'hw-bats hw-deco';
    layer.setAttribute('aria-hidden', 'true');
    [['papi-hw-bat-1.webp', '14vh', '24s', '2s'],
     ['papi-hw-bat-3.webp', '38vh', '31s', '11s'],
     ['papi-hw-bat-1.webp', '64vh', '27s', '19s']].forEach(function (b) {
      var w = document.createElement('div');
      w.className = 'hw-bat';
      w.style.top = b[1]; w.style.setProperty('--d', b[2]); w.style.setProperty('--delay', b[3]);
      w.appendChild(img(b[0]));
      layer.appendChild(w);
    });
    document.body.appendChild(layer);
  }

  /* ---- 4. the first section: a spider on a thread ------------------------- */
  function firstSection() {
    var nav = document.querySelector('.nav');
    var all = Array.prototype.slice.call(document.querySelectorAll('body > section, body > main > section, body > div > section'));
    return all.filter(function (s) { return s.offsetHeight > 300 && (!nav || !nav.contains(s)); })[0];
  }
  function spider() {
    var s = firstSection();
    /* Not on a product page: there the first section IS the product photo, and
       on a phone the spider landed on the bar itself. */
    if (!s || s.classList.contains('buy')) return;
    if (getComputedStyle(s).position === 'static') s.style.position = 'relative';
    var sp = document.createElement('div');
    sp.className = 'hw-spider hw-deco';
    sp.appendChild(img('papi-hw-spider.webp'));
    s.appendChild(sp);
  }

  /* ---- 5. cobwebs, every other big section, alternating corners ---------- */
  function webs() {
    var n = 0;
    Array.prototype.forEach.call(document.querySelectorAll('section'), function (s, i) {
      if (n >= 6 || i % 2 || s.offsetHeight < 420 || s.closest('.pcart')) return;
      if (s.classList.contains('hwhero')) return;   // has its own
      if (getComputedStyle(s).position === 'static') s.style.position = 'relative';
      s.appendChild(img('papi-hw-cobweb.webp', 'hw-web hw-deco ' + (n % 2 ? 'hw-web--r' : 'hw-web--l')));
      n++;
    });
  }

  /* ---- 6. jack-o'-lantern Papi on the page heads ------------------------- */
  function heads() {
    var h = document.querySelector('.phead h1, .bxhead h1, .nhead h1, .rhead h1');
    if (h) h.appendChild(img('papi-hw-papi-pumpkin.webp', 'hw-head hw-deco'));
  }

  /* ---- 7. footer sign-off: vampire Papi ---------------------------------- */
  function signoff() {
    var f = document.querySelector('footer.footer');
    if (!f || f.querySelector('.hw-signoff')) return;
    var d = document.createElement('div');
    d.className = 'hw-signoff';
    d.appendChild(img('papi-hw-papi-vampire.webp', '', 'Papi, dressed as a vampire'));
    var p = document.createElement('p');
    p.innerHTML = 'Happy Halloween from the famiglia.<small>Trick or treat? We know which one Papi picked.</small>';
    d.appendChild(p);
    f.insertBefore(d, f.firstChild);
  }

  /* ---- 8. ghost Papi ------------------------------------------------------
     Peeks in from the left once a third of the page has gone by, once per
     visit, and says one thing. If the season's bar is actually in the range
     right now (papi-cart.js dropped it otherwise), that thing is a link to it.
     ITS NAME IS NEVER WRITTEN IN THIS FILE: it comes from the theme's
     PAPI_SEASONAL_FLAVOURS, which the tease build does not emit. This file is
     public in every Halloween build, including the one up before the reveal. */
  var GHOST_KEY = 'papi_hw_ghost';
  function ghost() {
    try { if (sessionStorage.getItem(GHOST_KEY)) return; } catch (e) {}
    if (document.documentElement.getAttribute('data-papi-bar')) return;   // already on the bar
    var g = document.createElement('div');
    g.className = 'hw-ghost';
    g.appendChild(img('papi-hw-papi-ghost.webp'));
    var say = document.createElement('p');
    say.className = 'hw-ghost__say';
    var range = (window.PapiCart && window.PapiCart.flavours) || [];
    var seasonal = (window.PAPI_SEASONAL_FLAVOURS || []).map(function (f) { return f.slug; });
    var bar = range.filter(function (f) { return seasonal.indexOf(f.slug) !== -1; })[0];
    /* The tease build must not name the bar, and there is no bar in its range
       to link to anyway — it points back at the countdown instead. */
    var tease = (document.querySelector('meta[name="papi-season"]') || {}).content === 'halloween-tease';
    say.innerHTML = tease
      ? 'Boo. Something new crawls out <a href="/#hero">Monday at 7pm</a>.'
      : bar
      ? 'Boo. <a href="' + bar.href + '">' + bar.name + '</a> is a limited run. Get in before it&rsquo;s gone.'
      : 'Boo. Happy Halloween from Papi.';
    var x = document.createElement('button');
    x.type = 'button'; x.className = 'hw-ghost__x'; x.setAttribute('aria-label', 'Dismiss'); x.textContent = '×';
    x.addEventListener('click', function () { g.classList.remove('is-in'); });
    say.appendChild(x);
    g.appendChild(say);
    document.body.appendChild(g);

    var shown = false;
    function check() {
      if (shown) return;
      var depth = window.scrollY / Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
      if (depth < 0.33) return;
      shown = true;
      try { sessionStorage.setItem(GHOST_KEY, '1'); } catch (e) {}
      g.classList.add('is-in');
      window.removeEventListener('scroll', check);
      setTimeout(function () { g.classList.remove('is-in'); }, 9000);
    }
    window.addEventListener('scroll', check, { passive: true });
  }

  function boot() {
    /* Flipping a band re-points custom properties, and any element with a
       colour transition (the newsletter buttons, the CTAs) would then report
       its OLD colour to repair() for the next 300ms — it measured pre-flip
       colours and "fixed" a button to bone-on-bone. Transitions are off while
       the skin flips and measures, and back on the frame after. */
    var root = document.documentElement;
    root.classList.add('hw-booting');
    logos();
    flipBands();
    repair();
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { root.classList.remove('hw-booting'); });
    });
    bats();
    spider();
    webs();
    heads();
    signoff();
    ghost();
  }
  /* After DOMContentLoaded, not straight away: papi-cart.js builds and paints
     on that same event (it registered first, so it runs first), and repair()
     has to see the page in the state it paints. A deferred script always runs
     before DOMContentLoaded fires, so the listener is never late. */
  if (document.readyState === 'complete') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
